import { render, staticRenderFns } from "./BrandProductDetail.vue?vue&type=template&id=bf1e7836&scoped=true&"
import script from "./BrandProductDetail.vue?vue&type=script&lang=js&"
export * from "./BrandProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./BrandProductDetail.vue?vue&type=style&index=0&id=bf1e7836&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1e7836",
  null
  
)

export default component.exports